import './assets/styles/index.scss';
import Layout from './components/Layout';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import Projects from './pages/Projects';
import Articles from './pages/Articles';
import Contact from './pages/Contact';

function App() {

    return (
        <Routes>
            <Route path="/" element={<Layout />}>
                <Route exact path="/" element={<Home />}> </Route>
                <Route path="/projects" element={<Projects />}>Projects</Route>
                <Route path="/articles" element={<Articles />}>Articles</Route>
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<NotFound />}></Route>
            </Route>
        </Routes>
    );
}

export default App;
